import { render } from "./PatientToPayModal.vue?vue&type=template&id=04618599"
import script from "./PatientToPayModal.vue?vue&type=script&lang=js"
export * from "./PatientToPayModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__